import React from 'react';
import { generateArray } from '../utilities/ArrayHelpers';
import LowboyResourceCard from './LowboyResourceCard';

export default class LowboyResourceCards extends React.Component {
    render() {
        const { lowboyResource, cardsIndex } = this.props;

        if (!lowboyResource) {
            return null;
        }

        const lowboyResourceArray = generateArray(
            lowboyResource.requestedResourceCount
        );

        return (
            <div className="resource-cards-container">
                {lowboyResourceArray.map((i) => (
                    <div className="p-1" key={`cards-${cardsIndex}-${i}`}>
                        <LowboyResourceCard
                            key={`lr-${lowboyResource.id}-${i}`}
                            lowboyResource={lowboyResource}
                            cardIndex={cardsIndex * 1000 + i}
                            index={i}
                            {...this.props}
                        />
                    </div>
                ))}
            </div>
        );
    }
}
